// extracted by mini-css-extract-plugin
export default {"side":"side___nyo24","base":"base___Uv2yf"};